import { Directive, HostListener, inject, input } from '@angular/core';
import { AnalyticsService } from '../analytics.service';
import { LinkClickEvent, LinkTypeValues } from '../analytics.models';

@Directive({
  selector: 'a[appTrackedLink]',
})
export class TrackedLinkDirective {
  trackId = input.required<string>();
  trackType = input<LinkTypeValues>('other');

  private readonly analyticsService = inject(AnalyticsService);

  @HostListener('click', ['$event'])
  onClick(event: MouseEvent): void {
    const element = event.target as HTMLElement;
    const anchorElement = element.closest('a') as HTMLAnchorElement;

    const properties: LinkClickEvent = {
      linkId: this.trackId(),
      linkName: this.trackId(),
      linkType: this.trackType(),
      linkValue: anchorElement?.href || '',
    };

    this.analyticsService.trackLinkClick(properties);
  }
}
